module.exports = {
    /**
     * Main action entry generator, cannot be used directly since of predefined event types
     * Use action[eventType] methods instead, e.g. actionProgress
     *
     * @param {String} type
     * @param {String} actionName
     * @param {String} subActionName
     * @param overrides
     * @return {{event_type: *, event_data}}
     */
    action: function(type, actionName, subActionName, overrides) {
        var eventData = $.extend(true, {
            action_name: actionName,
            subaction_name: subActionName,
            action_category: 'user'
        }, overrides);

        return {
            event_type: type,
            event_data: eventData
        };
    },

    /**
     * Event type: action_completed
     *
     * @param {String} actionName
     * @param {String} subActionName
     * @param {{}} overrides
     * @return {*|{event_type, event_data}}
     */
    actionCompleted: function (actionName, subActionName, overrides) {
        return this.action('action_completed', actionName, subActionName, overrides);
    },

    /**
     * Event type: action_start
     *
     * @param {String} actionName
     * @param {String} subActionName
     * @param {{}} overrides
     * @return {*|{event_type, event_data}}
     */
    actionStart: function (actionName, subActionName, overrides) {
        return this.action('action_start', actionName, subActionName, overrides);
    },

    /**
     * Event type: action_progress
     *
     * @param {String} actionName
     * @param {String} subActionName
     * @param {{}} overrides
     * @return {*|{event_type, event_data}}
     */
    actionProgress: function (actionName, subActionName, overrides) {
        return this.action('action_progress', actionName, subActionName, overrides);
    },

    /**
     * Event type: action_end
     *
     * @param {String} actionName
     * @param {String} subActionName
     * @param {{}} overrides
     * @return {*|{event_type, event_data}}
     */
    actionEnd: function (actionName, subActionName, overrides) {
        return this.action('action_end', actionName, subActionName, overrides);
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/tracking/event.js
// module id = 6
// module chunks = 0 1 2 3 4 5 6 7 8 9 11 12 13 14